import { SET_SUGGESTIONS, CLEAR_SUGGESTIONS } from './actions';
import Resource from '../../../resource/Resource';

export function getUserSuggestion(params) {
  return (dispatch) => {
    Resource.lookup('search', 'suggestUser', params).then(
      ({ results: users }) => {
        dispatch({
          type: SET_SUGGESTIONS,
          users,
        });
      }
    );
  };
}

export function clearSuggestions() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_SUGGESTIONS,
      users: [],
    });
  };
}
